export { default } from './Collapse'
export type { CollapseProps } from './Collapse'
